export const DEFAULT_LANDING_ANIMATION_DURATION = {
  duration: 500,
  easing: 'easeInOutQuad',
} as const

export const LANDING_ANIMATION = {
  fade: {
    opacity: [0, 1],
  },
  fadeUp: {
    opacity: [0, 1],
    translateY: [100, 0],
  },
  fadeDown: {
    opacity: [0, 1],
    translateY: [-100, 0],
  },
  fadeRight: {
    opacity: [0, 1],
    translateX: [-100, 0],
  },
  fadeLeft: {
    opacity: [0, 1],
    translateX: [100, 0],
  },
} as const

export const LANDING_ANIMATION_MARGIN = {
  desktop: '0px 0px 0px 0px',
  mobile: '60px 0px 0px 0px',
} as const
